import React, { useEffect, useState, useCallback, useMemo } from "react";
import { getMediaSource } from "../../api/getMedia";
import UploadBanner from "./UploadBanner";
import UploadedIntroVideo from "./UploadIntroVideo";
import MediaTable from "./MediaTable";
import ChallengeTable from "./uploadChallange/ChallengeTable";

const UploadMedia = () => {
  const [mediaData, setMediaData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedTab, setSelectedTab] = useState("image");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const fetchMedia = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await getMediaSource();
      if (response?.data) {
        setMediaData(response.data);
      } else {
        setError("No media data found.");
      }
    } catch (err) {
      setError(err.message || "Failed to load media data.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMedia().then();
  }, [fetchMedia]);

  const filteredData = useMemo(() =>
    mediaData.filter(
      (item) =>
        (selectedTab === "image"
          ? item.folder === "banner"
          : item.folder === "video") &&
        item.fileName.toLowerCase().includes(searchTerm.toLowerCase())
    ), [mediaData, selectedTab, searchTerm]
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
    setSearchTerm("");
    setCurrentPage(1);
  };

  const handlePageChange = (direction) => {
    setCurrentPage((prevPage) => {
      if (direction === "prev" && prevPage > 1) return prevPage - 1;
      if (direction === "next" && prevPage < totalPages) return prevPage + 1;
      return prevPage;
    });
  };

  return (
    <div className="right-side-wrapper d-flex overflow-hidden w-full">
      <div className="container-fluid py-4">
        <div className="row g-4">
          <div className="col-lg-6 col-md-6"><UploadBanner referesh={fetchMedia} /></div>
          <div className="col-lg-6 col-md-6"><UploadedIntroVideo refresh={fetchMedia} /></div>
          {/* <div className="col-lg-4 col-md-12"><UploadChallenges refresh={fetchMedia} /></div> */}
        </div>

        <div className="row mt-5 px-2">
          <div className="col-lg-6 col-md-12 mb-3">
            <ul className="nav nav-pills mb-1 d-flex justify-content-start">
              {['image', 'video'].map((tab) => (
                <li className="nav-item" key={tab}>
                  <button
                    className={`nav-link ${selectedTab === tab ? 'active' : ''}`}
                    onClick={() => handleTabChange(tab)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-12 mb-3">
            {selectedTab !== "challenge" && (
              <div className="input-group">
                <input
                  type="text"
                  className="form-control custom-input"
                  placeholder="Search by file name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <button className="btn btn-outline-secondary" onClick={() => setSearchTerm("")}>Clear</button>
              </div>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            {loading ? (
              <div className="text-center py-2">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : error ? (
              <p className="text-danger text-center">{error}</p>
            ) : selectedTab === "challenge" ? (
              <ChallengeTable />
            ) : selectedTab === "video"  || selectedTab === 'image'? (
              <MediaTable mediaData={paginatedData} fetchMedia={fetchMedia} />
            ) : (
              <>
                
                <div className="pagination-controls d-flex justify-content-center mt-3">
                  <button className="btn btn-primary me-2" onClick={() => handlePageChange("prev")} disabled={currentPage === 1}>
                    ← Prev
                  </button>
                  <span className="align-self-center">Page {currentPage} of {totalPages}</span>
                  <button className="btn btn-primary ms-2" onClick={() => handlePageChange("next")} disabled={currentPage === totalPages}>
                    Next →
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadMedia;
